import {Tag} from "antd";
import React from "react";

const COLORS = ["orange", "red","cyan", "green", "blue", "purple", "lime"]
const getInitials = (data) => {
    if (data != null) {
        let chr;
        const d = data.toUpperCase();
        chr = d.split(" ");
        if (chr.length >= 2) {
            return chr[0][0] + chr[1][0];
        } else {
            return d[0] + d[1];
        }
    }
    return "";
}
const getColorForInitial = (letter = "") => {

    if (!letter?.length) return Object.keys(COLORS)[1];
    let code = letter.toUpperCase().charCodeAt(0);

    if (code > 64 && code < 91) {
        code -= 64;
        let activeColors = [
            ...COLORS,
            ...COLORS,
        ]
        let randomIndex = Math.floor((code / 26) * activeColors.length);
        return activeColors[randomIndex];
    }
}
const ColorTag = (props) => {
    const {label, value, closable, onClose} = props;
    const onPreventMouseDown = (event) => {
        event.preventDefault();
        event.stopPropagation();
    };
    return (
        <Tag
            key={label}
            // color={getColorForInitial(getInitials(label))}
            color="purple"
            onMouseDown={onPreventMouseDown}
            closable={closable}
            onClose={onClose}
            style={{
                marginRight: 3,
            }}
        >
            {label}
        </Tag>
    );
};


export default ColorTag;